module.exports = __webpack_public_path__ + "static/media/button-prev.8da624e6.svg";